import { BaseType } from '../base/base-type';
import { TaxStatusTypeIdEnum } from './tax-status-type-id.enum';

export class TaxStatusType extends BaseType {
  public declare id: TaxStatusTypeIdEnum;
}
